/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const AuthPostLogin = {
  id: 'authentication.login.post',
  tag: 'Authentication',
  summary: 'Login User',
  description: 'Users login',
  method: 'post',
  route: () => `/authentication/login`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.strictObject({
            email: ZodTypes.TrimmedString.min(1).email(),
            password: ZodTypes.Password,
          }),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.object({
            tokenType: z.literal('Bearer'),
            accessToken: z.string(),
            refreshToken: z.string(),
            expires: z.string().datetime(),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
